<template>
  <div class="form-container">
    <el-form label-width="130px" :model="form" :rules="rules" ref="form">
      <el-form-item label="油站名称">
        {{ userInfo.gasName }}
      </el-form-item>
      <el-form-item label="活动开始时间" prop="startDate">
        <div class="g-flx">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            placeholder="请选择开始时间"
            value-format="yyyy-MM-dd"
            :picker-options="startTimeOption">
          </el-date-picker>
          <span style="padding: 0 8px;">至</span>
          <el-date-picker
            v-model="form.endDate"
            type="date"
            placeholder="自动结束时间"
            value-format="yyyy-MM-dd"
            disabled>
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="姓名" prop="payeeName">
        <el-input placeholder="请输入姓名" v-model="form.payeeName" maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input placeholder="请输入手机号" v-model="form.mobile"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input placeholder="请输入身份证号" v-model="form.idCard"></el-input>
        <div class="card-tips">* 填入的身份证号必须与绑定的微信的实名认证身份证号一致</div>
      </el-form-item>
    </el-form>

    <div class="btn_groups">
      <div style="margin-bottom: 10px;">
        <el-checkbox v-model="haveRead">我已知悉并认同</el-checkbox>
        <span class="protal" @click="openToggleProtocol">《加油冲单活动协议》</span>
        <span class="protal" @click="signVisible = true">《灵活就业合作伙伴协议》</span>
      </div>
      <div>
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" @click="next">下一步</el-button>
      </div>
    </div>

    <el-dialog
      title="加油冲单活动协议"
      :visible.sync="toggleProtocol"
      :center="true"
      top="5%"
      width="600px">
      <div v-html="getXssIntro(protocolContent)"></div>
    </el-dialog>
    <!-- 《灵活就业合作伙伴协议》 -->
    <signAgreement v-if="signVisible" @close="signVisible = false"></signAgreement>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validator from '@/utils/validate'
import dayjs from 'dayjs'
import { getProtocol, addReadRead } from '@/api/marketPromotion/signUpActive'
import { searchActiveDate } from '@/api/runAchieve/signUp'
import { getXssIntro } from '@/utils/xss'
import signAgreement from '../components/signAgreement.vue'

export default {
  name: 'first',
  components: { signAgreement },
  data () {
    let _this = this
    const checkEndTime = (rule, value, callback) => {
      if (this.form.startDate > this.form.endDate) {
        callback(new Error('结束时间不能小于开始时间'))
      } else {
        callback()
      }
    }
    return {
      haveRead: false,
      toggleProtocol: false,
      protocolContent: '',
      endDate: '',
      canJoinDays: 0,
      form: {
        startDate: '',
        endDate: '',
        mobile: '',
        payeeName: '',
        idCard: ''
      },
      rules: {
        startDate: [{ required: true, message: '请选择活动开始时间', trigger: 'change' }],
        endDate: [
          { required: true, message: '请选择活动结束时间', trigger: 'change' },
          { validator: checkEndTime, trigger: 'change' }
        ],
        mobile: [
                { required: true, message: '收款人手机号不能为空', trigger: 'blur' },
                { validator: validator.checkPhone, trigger: 'blur' }
              ],
        payeeName: [{ required: true, message: '收款人姓名不能为空', trigger: 'blur' }],
        idCard: [{ required: true, validator: validator.validateIdCard, trigger: 'blur' }]
      },
      startTimeOption: {
        disabledDate(time) {
          return dayjs(time).valueOf() < dayjs().valueOf() || dayjs(time).valueOf() > dayjs(_this.endDate).valueOf()
        }
      },
      signVisible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  watch: {
    'form.startDate' (val) {
      this.form.endDate = dayjs(val).add(this.canJoinDays - 1, 'day').format('YYYY-MM-DD')
    }
  },
  methods: {
    getXssIntro,
    next () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (!this.haveRead) return this.$message.error('请勾选加油冲单活动协议、灵活就业合作伙伴协议')
          // 调用阅读记录接口
          await addReadRead({ protocolType: 'offsetOrder' })
          Object.assign(this.form, this.$route.query)
          this.$emit('submit', this.form)
        }
      })
    },
    // 查询协议
    async getProtocol () {
      try {
        const {code, result} = await getProtocol({ protocolType: 'offsetOrder' })
        if (code !== 200) return
        this.protocolContent = decodeURIComponent(result.protocolContent)
        this.haveRead = result.haveRead
      } catch (error) {
        console.log(error)
      }
    },
    // 查看协议
    openToggleProtocol () {
      this.toggleProtocol = true

    },
  },
  async created() {
    this.getProtocol()
    const {code, result} = await searchActiveDate(this.$route.query)
    if (code !== 200) return
    this.endDate = result.endDate
    this.canJoinDays = result.canJoinDays
  },
}
</script>
<style lang="less" scoped>
  .form-container {
    // width: 460px;
    margin-top: 30px;
    .el-input, .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 200px;
    }
    .card-tips {
      font-size: 12px;
      color: #999999;
    }
    .protal{
      color: #5087FF;
      font-size: 14px;
      cursor: pointer;
    }
    .btn_groups {
      width: 100%;
      position: absolute;
      bottom: 20px;
      text-align: center;
    }
  }
</style>
